import {
  ORGANIZATION_USER_LEARNER,
  ORGANIZATION_USER_STAFF,
} from '../data/models/Oganization/Organization';

export const getUserRoleName = (userType?: number): string => {
  if (userType === ORGANIZATION_USER_LEARNER) {
    return 'learner';
  }
  if (userType === ORGANIZATION_USER_STAFF) {
    return 'staff';
  }
  return 'unknown';
};

export const isInstructor = (userType?: number): boolean => {
  return userType === ORGANIZATION_USER_STAFF;
};

export const isLearner = (userType?: number): boolean => {
  return userType === ORGANIZATION_USER_LEARNER;
};
